import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchPost, objectify } from '../../utils'


export const search = (query) => {
  const { ProductId, filters, Page, Sort, SortDirection, BatchSize = DEFAULT_PAGE_SIZE } = query;
  return fetchPost(`/InventoryEnquiry/Product/${ProductId}/Reordering/PurchaseOrders`,
    { ...filters, Sort: Sort && SortDirection && `${Sort}:${SortDirection}` }, { BatchPage: Page, BatchSize },
    'Inline')
    .then((result) => result && result.ProductPurchaseOrders &&
      ({
        records: result.ProductPurchaseOrders.map(item => objectify(item, null, 'Inline')),
        nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
        currPage: result.BatchInformation && result.BatchInformation.BatchPage,
      }))
}
